import CardItem from "app/components/organisms/CardItem";
import { View } from "ui/atoms/view";
import { Text } from "react-native";
import { ColumnModel } from "app/services/api/types/common/models/ColumnModel";

interface Props<T> {
  item: T;
  columns: ColumnModel<T>[];
}
export function MobileTableCard<T>({ item, columns }: Props<T>) {
  const content = (
    <View className="grid sm:grid-cols-2">
      {columns.map((column, index) => (
        <View
          className="flex flex-col py-3"
          key={column.dataKey?.toString() ?? `column-${index}`}
        >
          <Text className="text-gray-600 mb-2">{column.title}</Text>
          {column.renderCell ? (
            column.renderCell(item)
          ) : column.dataKey ? (
            <Text>
              {String(
                column.transform
                  ? column.transform(item[column.dataKey], item)
                  : item[column.dataKey],
              )}
            </Text>
          ) : null}
        </View>
      ))}
    </View>
  );

  return <CardItem actionButtons={<></>} cardContent={content}></CardItem>;
}
